import { useTranslate } from "@similarweb/i18n-provider";

import { PlaybookConfirmationModal } from "../PlaybookConfirmationModal/PlaybookConfirmationModal";

type DeletePlaybookModalProps = {
    isOpen: boolean;
    isShared: boolean;
    playbookName: string;
    isDeleting: boolean;
    onCancel: () => void;
    onConfirm: () => void;
};

export const DeletePlaybookModal = ({
    isOpen,
    isShared,
    playbookName,
    isDeleting,
    onCancel,
    onConfirm,
}: DeletePlaybookModalProps) => {
    const { translate } = useTranslate();

    const confirmationKey = isShared ? "si.playbooks.delete.shared.confirmation" : "si.playbooks.delete.confirmation";

    return (
        <PlaybookConfirmationModal
            isOpen={isOpen}
            title={translate(isShared ? "si.playbooks.delete.shared.title" : "si.playbooks.delete.title")}
            description={
                <span
                    dangerouslySetInnerHTML={{
                        __html: translate(confirmationKey, { name: playbookName }),
                    }}
                />
            }
            confirmLabel={translate(isShared ? "si.playbooks.delete.shared.confirm" : "si.common.button.delete")}
            confirmButtonType="warning"
            isLoading={isDeleting}
            onCancel={onCancel}
            onConfirm={onConfirm}
            dataAutomation="delete-playbook-modal"
        />
    );
};
